import request from '../../utils/request'
import { UrlSearch } from "../../utils/UrlSearch";
const shopTitle = UrlSearch().shop;
let shopName ;
if(shopTitle){
  let index = shopTitle.indexOf('.');
  if(index>0){
      shopName = shopTitle.substring(0,index);
  }else{
      shopName = shopTitle;
  }

}

export function orderlist(param){
    param.shopName = shopName;
    return request({
      url: `get-order-list`,
      method: 'post',
      params: param
    })
  }

  export function  getorderproduct(param){
    param.shopName = shopName;
    return request({
      url: `get-order-product`,
      method: 'post',
      params: param
    })
  }

  export function  updateorderstatus(param){
    param.shopName = shopName;
    return request({
      url: `update-order-status`,
      method: 'post',
      params: param
    })
  }


  export function  getshippingmethod(param){
    param.shopName = shopName;
    return request({
      url: `get-shipping-method`,
      method: 'post',
      params: param
    })
  }
  
  
  export function  getorderlog(param){
    param.shopName = shopName;
    return request({
      url: `get-order-log`,
      method: 'post',
      params: param
    })
  }


  export function  processingorder(param){
    param.shopName = shopName;
    return request({
      url: `processing-order`,
      method: 'post',
      params: param
    })
  }
 


// WEBPACK FOOTER //
// ./src/components/views/api/orderlist.js